import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { useState } from "react";

interface DocumentInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    value: string | null;
    onChange: (value: string) => void;
    type: "cpf" | "cnpj";
    error?: string;
}

export function DocumentInput({
    value,
    onChange,
    type,
    error,
    className,
    ...props
}: DocumentInputProps) {
    const [inputValue, setInputValue] = useState("");

    const formatDocument = (value: string) => {
        // Remove todos os caracteres não numéricos
        const numbers = value.replace(/\D/g, '');

        // Se não tiver números, retorna vazio
        if (!numbers) return '';

        if (type === "cpf") {
            // Formata CPF: 000.000.000-00
            if (numbers.length <= 3) {
                return numbers;
            } else if (numbers.length <= 6) {
                return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
            } else if (numbers.length <= 9) {
                return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
            } else {
                return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
            }
        } else {
            // Formata CNPJ: 00.000.000/0000-00
            if (numbers.length <= 2) {
                return numbers;
            } else if (numbers.length <= 5) {
                return `${numbers.slice(0, 2)}.${numbers.slice(2)}`;
            } else if (numbers.length <= 8) {
                return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5)}`;
            } else if (numbers.length <= 12) {
                return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8)}`;
            } else {
                return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8, 12)}-${numbers.slice(12, 14)}`;
            }
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        // Remove todos os caracteres não numéricos
        const numbers = newValue.replace(/\D/g, '');
        setInputValue(formatDocument(numbers));
        onChange(numbers);
    };

    return (
        <Input
            {...props}
            type="text"
            value={inputValue}
            onChange={handleChange}
            placeholder={type === "cpf" ? "000.000.000-00" : "00.000.000/0000-00"}
            className={cn(
                "font-mono",
                error && "border-red-500 focus-visible:ring-red-500",
                className
            )}
        />
    );
} 